module.exports = "/legacy/7eb237d58f399f43d5c51c651bed6afc.svg";